import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TGbpMonthlyExchangeRateRow } from './types';

export const tableStructure: TTableStructure<keyof TGbpMonthlyExchangeRateRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		name: 'Year',
		selector: 'year',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Month',
		selector: 'month',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		// Picking this filter opens the year-month picker, which leaves `?period=YYYY-MM` in the url —
		// the component turns that into the `year` and `month` filters the endpoint knows.
		name: 'Date',
		selector: 'period',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		separateFilter: true,
		type: ETableStructureType.DATE_MONTH,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Currency',
		selector: 'currency',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'To GBP Rate',
		selector: 'to_gbp_rate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
];
